import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const Solcellsofferter = lazy(() => import("@/pages/info/Solcellsofferter"));

export const Route = createFileRoute("/solcellsofferter")({
  head: () => seoHead("/solcellsofferter", { description: "Jämför offerter från upp till fyra solcellsleverantörer. Helt kostnadsfritt och utan förpliktelser." }),
  component: () => <Solcellsofferter />,
});
